import React from 'react';

import { QStack, QText } from '@captivateiq/quotient';

import type { Message } from '@captivateiq/assistant/types';

type UserMessageProps = {
  message: Message;
};
export const UserMessage = ({ message }: UserMessageProps) => {
  return (
    <QStack
      direction="row"
      sx={{
        alignItems: 'center',
        backgroundColor: 'primary.200',
        border: '1px solid',
        borderColor: 'primary.300',
        borderRadius: '8px',
        justifyContent: 'stretch',
        padding: '12px',
      }}
    >
      <QText
        sx={{
          color: 'primary.900',
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: '20px',
        }}
      >
        {message.contents}
      </QText>
    </QStack>
  );
};
